import React, { Children, useState } from "react";

type Props = {
  children?: React.ReactNode;
  name: string;
  displayName: string;
  withExpand?: boolean;
  isExpand?: boolean;
  setExpandState?: (key: string, value: boolean) => void;
};

export default function PreferenceWrapper({
  name,
  displayName,
  children,
  isExpand = false,
  withExpand = true,
  setExpandState = () => {},
}: Props) {
  const expand = withExpand ? isExpand : true;
  const onClickExpand = () => {
    setExpandState(name, !isExpand);
  };

  return (
    <div
      className={withExpand ? "property-wrapper" : "property-wrapper children"}
    >
      <div
        className="property-wrapper-header"
        onClick={withExpand ? onClickExpand : () => {}}
      >
        <div>{displayName}</div>
        {withExpand && (
          <div>
            {expand && (
              <svg
                width="16"
                height="8"
                viewBox="0 0 16 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M8 0L16 8L1.91403e-07 8L8 0Z" fill="#313131" />
              </svg>
            )}
            {!expand && (
              <svg
                width="16"
                height="8"
                viewBox="0 0 16 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M8 8L0 0L16 1.6032e-06L8 8Z" fill="#313131" />
              </svg>
            )}
          </div>
        )}
      </div>
      <div className="property-wrapper-children">{expand && children}</div>
    </div>
  );
}
